/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconDeviceDesktopExclamation = createReactComponent("outline", "device-desktop-exclamation", "IconDeviceDesktopExclamation", [["path", { "d": "M15 16h-11a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v7", "key": "svg-0" }], ["path", { "d": "M7 20h8", "key": "svg-1" }], ["path", { "d": "M9 16v4", "key": "svg-2" }], ["path", { "d": "M15 16v4", "key": "svg-3" }], ["path", { "d": "M19 16v3", "key": "svg-4" }], ["path", { "d": "M19 22v.01", "key": "svg-5" }]]);

export { IconDeviceDesktopExclamation as default };
//# sourceMappingURL=IconDeviceDesktopExclamation.mjs.map
